export default {
  name: 'message-list',
  functional: true,
  render(createElement, { props, listeners }) {

    let message = props.msg.message_contents;
    let msgArr = message.split(/{{|}}/);
    // console.log(msgArr)
    let labels = [];
    msgArr.map(item => {
      let aLabel,spanLabel;
      if(item === 'file' && message.indexOf('{{file}}') > -1 && props.msg.message_content_object.file){
        aLabel = createElement('a', {
          on: {
            click: listeners.goToFile
          }
        },[props.msg.message_content_object.file.name]);
        labels.push(aLabel)
      }else if(item === 'myshare' && message.indexOf('{{myshare}}') > -1 && props.msg.message_content_object.myshare){
        aLabel = createElement('a', {
          on: {
            click: listeners.goToMyShare
          }
        },[props.msg.message_content_object.myshare.name]);
        labels.push(aLabel)
      }else if(item === 'share' && message.indexOf('{{share}}') > -1 && props.msg.message_content_object.share){
        aLabel = createElement('a', {
          on: {
            click: listeners.goToShareMe
          }
        },[props.msg.message_content_object.share.name]);
        labels.push(aLabel)
      }else if(item === 'user' && message.indexOf('{{user}}') > -1 && props.msg.message_content_object.user){
        aLabel = createElement('a', {
          on: {
            click: listeners.goToUser
          }
        },[props.msg.message_content_object.user[0].name]);
        labels.push(aLabel)
      }else if(item === 'group' && message.indexOf('{{group}}') > -1 && props.msg.message_content_object.group){
        aLabel = createElement('a', {
          on: {
            click: listeners.goToGroup
          }
        },[props.msg.message_content_object.group.name]);
        labels.push(aLabel)
      }else if(item === 'application' && message.indexOf('{{application}}') > -1 && props.msg.message_content_object.application){
        aLabel = createElement('a', {
          on: {
            click: listeners.goToApp
          }
        },[props.msg.message_content_object.application.name]);
        labels.push(aLabel)
      }else if(item === 'other' && message.indexOf('{{other}}') > -1 && props.msg.message_content_object.other){
        aLabel = createElement('a', {
          on: {
            click: listeners.goToOther
          }
        },[props.msg.message_content_object.other.name]);
        labels.push(aLabel)
      }else if(item && item.trim()){
        spanLabel = createElement('span', {},[item]);
        labels.push(spanLabel)
      }
    })

    // console.log(labels)
    return createElement(
      'div',
      {
        class: {
          cont: true
        }
      },
      labels
    );
  }
}
